import { styled } from "styled-components";

export const FormContainer = styled.div`
	padding: 30px 24px 50px;
	margin-bottom: 30px;
	border: 1px solid #b8c8cf;
	box-shadow: 0px 10px 50px rgba(0, 103, 112, 0.05);
	border-radius: 10px;

	h3 {
		font-size: 1.5rem;
		font-weight: bold;
	}

	.headerActions {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin-bottom: 30px;

		button {
			margin: 0 12px;
			padding: 10px 40px;
			border-radius: 20px;

			.MuiButton-startIcon {
				margin-right: 18px;
				position: relative;
				top: -1px;
			}
		}
	}
`;

export const StyledForm = styled.form`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 24px;
	margin-top: 20px;

	.LeftSection {
		width: 18%;
		max-width: 200px;

		.productDetails {
			padding: 40px 16px 38px;
			margin-bottom: 30px;
			margin-top: 16px;
			border: 1px solid #b8c8cf;
			border-radius: 14px;

			img {
				width: 100%;
				padding-bottom: 20px;
			}

			h6 {
				color: #677585;
				font-weight: 600;
				margin-bottom: 8px;
			}
			p {
				color: #11293b;
				font-weight: 500;
			}
		}

		button {
			font-size: 13px;
			padding: 12px 24px;
			border-radius: 20px;

			&.updateButton {
				padding: 10px 50px;
			}
			&.cancelButton {
				padding: 10px 50px;
				margin-top: 16px;
			}
		}
	}

	.RightSection {
		width: 80%;
		&.w-full {
			width: 100% !important;
			padding-left: 20px;
			padding-right: 20px;
		}
	}

	.headerActions {
		justify-content: space-between;
		margin-top: 18px;
		padding: 22px 24px;
		border: 1px solid #b8c8cf;
		border-radius: 14px;

		.progress {
			width: 37%;
		}
	}

	/* Input Fields */
	.form-group {
		color: #555;
		margin-top: 30px;
		display: flex;
		flex-direction: column;
		gap: 20px;

		label {
			color: #999999;
			font-weight: 400;
			font-size: 12px;
		}
	}

	.inputText,
	input,
	textarea,
	select {
		font-weight: 600;
	}

	.inputText {
		width: fit-content;
		word-break: break-word;
		padding-right: 12px;
		/* text-transform: capitalize; */
	}

	.text_view {
		font-size: 17px;
		font-weight: 500;
		padding: 14px;
		border-radius: 5px;
		border: 1px solid #b8c8cf;
		background: #eff8f9;
	}

	input.edit,
	textarea.edit {
		margin-right: 16px;
		padding: 8px 14px;
		border-radius: 6px;
		border: 1px solid #b8c8cf;
	}

	select.edit {
		padding: 8px 14px;
		border-radius: 6px;
		border: 1px solid #b8c8cf;
	}

	.selectBadge {
		display: flex;
		align-items: center;
		gap: 24px;
		text-transform: uppercase;

		span {
			color: #333;
			padding: 8px 30px;
			border-radius: 5px;
			background: rgba(255, 120, 120, 0.2);
		}

		.statusIcon {
			font-size: 28px;
		}

		&.pending {
			span {
				background: #f9ffae;
			}
		}

		&.active,
		&.delivered,
		&.success,
		&.fixed,
		&.released,
		&.completed,
		&.settled,
		&.approved {
			span {
				background: #dcf4e6;
			}
			.statusIcon {
				color: #00c24e;
			}
		}

		&.inactive,
		&.error,
		&.declined {
			span {
				background: #fde8e8;
			}
			.statusIcon {
				color: #ff0000;
			}
		}
	}

	.fileGroup {
		font-weight: 500;

		.viewFileBtn {
			display: flex;
			align-items: center;
			gap: 18px;
			padding: 10px 18px;
			width: fit-content;
			white-space: nowrap;
			border-radius: 6px;
			background: #006770;
			color: #fff;
			font-size: 13px;

			.fileIcon {
				color: #fff;
				font-size: 19px;
			}
		}
		.side_btn {
			/* font-weight: 500; */
		}
	}
`;
